export default "__VITE_ASSET__PlVd6BDD__"